/**
 * modalEmitter — dispara eventos globais para exibir AppModal
 * fora do contexto React (ex: interceptors Axios).
 *
 * Uso:
 *   showGlobalModal({ variant, title, message, confirmText, cancelText, redirectOnConfirm })
 */
export const showGlobalModal = (config) => {
  window.dispatchEvent(new CustomEvent("app:global-modal", { detail: config }));
};
